const AccountHeading = ({ icon: Icon, title }) => (
  <div className="sub-heading-container">
    <div className="icon right-margin w-embed">{Icon && <Icon />}</div>
    <h2 className="heading-title-2">{title}</h2>
  </div>
)

export default AccountHeading
